/** Formata um número como moeda brasileira (R$) com duas casas decimais. */
export function money(v: number): string {
  return "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Formata um timestamp ISO em HH:mm no fuso local. */
export function time(value: string): string {
  return new Date(value).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}

/** Formata um intervalo de tempo em "HH:mm–HH:mm". */
export function timeRange(start: string, end: string): string {
  return `${time(start)}–${time(end)}`;
}

/** Formata uma data ISO (YYYY-MM-DD ou timestamp) em dd/mm/aaaa. */
export function formatDate(value: string): string {
  const [year, month, day] = value.slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : value;
}

/** Formata um timestamp ISO em dd/mm/aaaa HH:mm no fuso local. */
export function formatDateTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const pad = (part: number) => String(part).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
